module.exports = __webpack_public_path__ + "static/media/background7.ae55db37.jpg";